import Mixpanel from "mixpanel-browser";

Mixpanel.init("c6c36c653a8549aa926590d6a2b4c5e1");

export default Mixpanel;
